import { theme } from 'styles';

export const multiSelectStyles = (isMobile: boolean) => ({
  height: '56px',
  borderRadius: '4px',
  opacity: 1,
  '.MuiSelect-select.MuiSelect-select': {
    height: '56px',
    overflowY: 'auto',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: '6px 32px 6px 4px',
    boxSizing: 'border-box',
    '& > div': {
      margin: 0,
    },
  },
  '.MuiSvgIcon-root.MuiSelect-icon': {
    top: isMobile ? '12px' : '50%',
    transform: isMobile ? 'none' : 'translateY(-50%)',
  },
});

export const optionSx = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  alignContent: 'center',
  width: '44px',
  height: '44px',
  padding: '0',
  borderRadius: '15px',
  '&.Mui-selected, &.Mui-selected:hover': {
    backgroundColor: theme.palette.info.light,
  },
};

export const dropdownContainerSx = (isMobile: boolean) => ({
  maxWidth: '600px',
  paddingLeft: '16px',
  '.MuiPaper-root': {
    minWidth: `${isMobile ? '280px' : '320px'} !important`,
    marginTop: '-20px',
  },
  '.MuiList-root': {
    maxHeight: '320px',
    paddingLeft: isMobile ? '8px' : '12px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: isMobile ? 'space-evenly' : 'flex-start',
  },
});

export const selectSx = {
  '.MuiSelect-select.MuiSelect-select': {
    paddingLeft: '24px',
  },
};

export const selectMobileSx = {
  minHeight: '60px',

  '.MuiSelect-select.MuiSelect-select': {
    padding: '10px 16px',
    '&.Mui-disabled': {
      height: '100%',
    },
  },
};
